import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { ZariContext } from '_zari/context'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const IdDepartamentoFormGroup = ({
  values,
  setValues,
  handleChange,
  iError,
  iTouched,
  fIsSubmitting
}) => {
  const __zariContext = React.useContext(ZariContext)
  const [departamentos, setDepartamentos] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.DEPARTAMENTO)
      .then(({ data }) => setDepartamentos(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='DEPARTAMENTO' htmlFor='select-idDepartamento' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Field name='_idDepartamento'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idDepartamento'
              onChange={e => {
                handleChange(e)
                values._idDepartamento = e.target.value
                values._idProvincia = ''
                values._idDistrito = ''
                setValues(values)
              }}
            >
              <option value=''>Seleccionar</option>
              {departamentos.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdDepartamentoFormGroup)
